const searchHelpers = {
	searchFieldsAndAdditionals(headers, additionalFields = []) {
		return (value, search, item) => {
			if (!search) return true;

			const searchLower = search.toLowerCase();
	
			const searchableColumns = headers
				.filter(header => header.filterable !== false)
				.map(header => header.value);

			const fieldsToSearch = [...searchableColumns, ...additionalFields];
			return fieldsToSearch.some(field => {
				const fieldValue = item[field];
				return Array.isArray(fieldValue)
					? fieldValue.some(element => element?.toString().toLowerCase().includes(searchLower))
					: fieldValue?.toString().toLowerCase().includes(searchLower);
			});
		};
	},

	searchByNameAndOverwritten(nameFieldName = 'name') {
		return (search, item) => {
			return item[nameFieldName]?.toLowerCase()?.includes(search.toLowerCase()) ||
				item['overwrittenNames']?.some(name => name.toLowerCase().includes(search.toLowerCase()));
		}
	}
};

export {searchHelpers};